import { Injectable, inject } from '@angular/core';

import { ConvoParticipantService } from './convo-participant.service';
// import { GeoService } from './geo.service';
import { PerformerService } from './performer.service';
import { SceneService } from './scene.service';
import { ShareScreenParticipantService } from './share-screen/share-screen-participant.service';

@Injectable()
export class CleanUpTasksService {
  public initialized = false;
}
